import _ from 'lodash'
import { getAxios, getPreviewDynamicData } from '../../lib/projectAxios'
import * as actionTypes from './actionTypes'
import { fromJS, List, Map } from 'immutable'
import { processTableValueRules } from '../../lib/rules'
import { getParentIdInModal } from '../../constants/toUnits'
import { doProcessRules } from '../../lib/processPortalRules'
const axios = getAxios()

export const updateTableRecords = (pageUID, uid, columns, component, errorTo) => async (dispatch, getState) => {
  let state = getState()
  let elem = state.getIn(['pages', state.get('page'), `Props`, 'elements', uid])
  if (!elem) {
    elem = state.getIn(['project', `Settings`, 'elements', uid])
  }
  if (elem && Map.isMap(elem)) {
    component = elem
  }
  let parentUID
  if (pageUID === 'project') {
    parentUID = getParentIdInModal(state, component.get('parent'), pageUID === 'project')
  } else {
    parentUID = pageUID
  }

  let modified = state.getIn(['state', pageUID, `bulk-${uid}`], Map()).toJS()
  let defaultData = state.getIn(['state', parentUID, uid], Map()).toJS()
  let hashCols = {}

  let listCols = component.getIn(['props', 'columns'], List()).toJS()
  _.each(listCols, function (col) {
    if (col && _.get(col, ['meta', 'allowEdit']) && !_.get(col, ['meta', 'field', 'calculated'])) {
      col.fieldType = _.get(col, ['meta', 'field', 'type'])
      hashCols[col.id] = col
    }
  })
  let updateRequest = {}
  let isError = false
  _.each(modified, function (col, colID) {
    if (hashCols[colID]) {
      _.each(col, function (val, index) {
        if (val !== undefined) {
          if (!updateRequest[index]) {
            let ftHash = ''
            if (_.get(defaultData, ['valueFTHash']) && typeof _.get(defaultData, ['valueFTHash']) == 'object') {
              ftHash = _.get(defaultData, ['valueFTHash', index])
            } else {
              ftHash = _.get(defaultData, ['valueFTHash'])
            }
            updateRequest[index] = {
              valueFTHash: ftHash,
            }
            _.each(hashCols, function (col) {
              if (_.get(col, 'meta.field.updateable')) {
                // || _.get(col, 'meta.field.createable')
                const defValue = _.get(col, 'meta.field.type') === 'boolean' ? false : null
                if (['reference', 'multipicklist', 'picklist'].indexOf(col.fieldType) == -1) {
                  if (_.isArray(_.get(defaultData, [col.id]))) {
                    updateRequest[index][col.id] = _.get(defaultData, [col.id, index], defValue)
                  } else {
                    updateRequest[index][col.id] = _.get(defaultData, [col.id], defValue)
                  }
                }
              }
            })
          }
          if (['reference', 'multipicklist', 'picklist'].indexOf(hashCols[colID].fieldType) > -1) {
            updateRequest[index][colID] = modified[`${colID}-value`][index] || null
          } else {
            updateRequest[index][colID] = val
          }

          let formFieldStatus = fromJS(
            dispatch(
              processTableValueRules(uid, colID, [pageUID, uid], index, updateRequest[index][colID], false, component)
            )
          )
          if (formFieldStatus.getIn(['status']) == 'error') {
            isError = true
          }
        }
      })
    }
  })

  component.getIn(['props', 'columns'], List()).map((col) => {
    _.each(updateRequest, (row, index) => {
      let value = row[col.get('id')]
      if (value === undefined || value === null) {
        value = _.get(defaultData, [col.get('id'), index], row[col.get('id')])
      }
      let formFieldStatus = fromJS(
        dispatch(processTableValueRules(uid, col.get('id'), [pageUID, uid], index, value, false, component))
      )
      if (formFieldStatus.getIn(['status']) == 'error') {
        isError = true
      }
    })
  })

  if (isError) {
    return {
      status: false,
      code: 'value_rule',
    }
  }

  try {
    dispatch({
      type: actionTypes.START_QUICK_UPDATE_TABLE,
      payload: {
        pageUID,
        uid,
      },
    })

    const { status, data } = await axios.post('/webprojects/update/powerTableRecords', {
      data: {
        list: updateRequest,
        uid,
        pageUID,
      },
    })

    if (data && data.status == false) {
      const messages = [
        {
          title: _.map(data.errors, function (row) {
            return row.error.join(', ')
          }).join(', '),
        },
      ]
      let isHaveMessage = _.compact(_.map(messages, (msg) => msg.title)).length > 0
      if (isHaveMessage) {
        dispatch({
          type: actionTypes.SHOW_SF_NOTIFY_MESSAGES,
          payload: {
            messages,
          },
        })
        if (errorTo) {
          dispatch(setVariableValue(errorTo, messages[0].title))
        }
      }
    }
    dispatch({
      type: actionTypes.APPLY_QUICK_UPDATE_TABLE,
      payload: {
        pageUID: parentUID,
        uid,
        data,
        updateRequest,
      },
    })
    return {
      status: data.status,
      ...(_.isEmpty(updateRequest) ? { code: 'no-data' } : {}),
    }
  } catch (err) {
    console.error(err)
    dispatch({
      type: actionTypes.SHOW_SF_NOTIFY_MESSAGES,
      payload: {
        messages: [
          {
            title: err,
          },
        ],
      },
    })
    if (errorTo) {
      dispatch(setVariableValue(errorTo, String(err)))
    }
  }
  return {
    status: false,
  }
}

export const setVariableValue = (key, value) => (dispatch, getState) => {
  let state = getState()
  const [ext, idPath] = String(key).split('##')
  if (ext === 'param') {
    state = state.setIn(['params', idPath], value)
    state = doProcessRules(state, false, [], [idPath], null, false, false)
  } else if (ext === 'pageParam') {
    const paramPath = String(idPath).split(':')
    state = state.setIn(['state', ...paramPath], value)
    state = doProcessRules(state, false, [], paramPath, null, false, false)
  }

  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: state,
    },
  })
}

export const updateTableRecord = (value, uid, ids, colID, errorTo) => async (dispatch) => {
  const { status, data } = await axios.post('/webprojects/update/powerTable', {
    data: {
      value,
      uid,
      ids,
      colID,
    },
  })

  if (data && data.status == false) {
    let errors = _.map(data.error, function (error) {
      try {
        let parsedError = JSON.parse(error)
        if (parsedError && parsedError[0] && parsedError[0].message) {
          return parsedError[0].message
        } else {
          return error
        }
      } catch (err) {
        return error
      }
    })
    if (errorTo) {
      dispatch(setVariableValue(errorTo, errors[0]))
    }
    dispatch({
      type: actionTypes.SHOW_SF_NOTIFY_MESSAGES,
      payload: {
        messages: [
          {
            title: errors[0],
          },
        ],
      },
    })
    return errors
  }
}
